import "react-sortable-tree/style.css";
import {
  Button,
  Grid,
  makeStyles,
  Paper,
  FormControl,
  InputAdornment,
  OutlinedInput,
  MenuItem,
  Select,
  withStyles,
  InputBase,
  Dialog,
  DialogContent,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Select as AntSelect } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Pagination, PaginationItem } from "@material-ui/lab";
import SearchIcon from "@material-ui/icons/Search";
import { useHistory } from "react-router-dom";

import "../../../styles/tree-styles.css";
import ActionMessages from "../../../common-components/ActionMessages";
import Loading from "../../../common-components/Loading";
import {
  createDelegatedResourceHistory,
  getDelegatedResourceHistory,
  getAdminDepartments,
  getResourceListForDelegation,
  getResourceListForDelegationFromRole,
} from "../../../actions/admin-actions";
import {
  converDateFormatForPicker,
  formatBackToDateFromSetting,
  formatDateBySetting,
  getResponse,
  getPaginationPageNumber,
  getTimeZomeOffDate,
} from "../../../shared-resources/utils";
import EditIcon from "@material-ui/icons/Edit";
import DeleteForeverIcon from "@material-ui/icons/DeleteForeverOutlined";
import CustomDatePicker from "../../../common-components/CustomDatePicker";

const Delegations = ({ data, type }) => {
  const useStyles = makeStyles((theme) => ({
    tablePaper: {
      borderRadius: "12px",
      marginTop: "12px",
    },
    actionBtnContainer: {
      position: "absolute !important",
      left: "-10%",
      margin: "0px 1",
    },
    checkCircleIcon: {
      fontSize: "18px",
      color: "#075e07",
      cursor: "pointer",
      marginTop: "2px",
    },
    checkCircleIconSpan: {
      cursor: "pointer",
      marginLeft: "2px",
    },
    paginationSection: {
      marginTop: "4px",
    },
    searchSection: {
      marginBottom: "4px",
      display: "flex",
      width: "100%",
    },
    searchIcon: {
      color: "#ccc",
    },
    searchTextField: {
      borderRadius: "25px",
      fontSize: "14px",
      height: "36px",
      outline: "none !important",
      marginLeft: "15px",
    },
    editIcon: {
      fontSize: "14px",
      color: "#ccc",
      cursor: "pointer",
    },
    editTextField: {
      height: "24px",
      fontSize: "12px",
      width: "180px",
      padding: "2px",
      background: "#fff",
    },
    editText: {
      padding: "0",
    },
    locationField: {
      height: "36px",
      borderRadius: "25px",
      fontSize: "13px",
    },
    addBtn: {
      fontSize: "12px",
      fontWeight: "600",
      padding: "2px 15px !important",
      textTransform: "none",
      border: "1px solid #3599d1",
      color: "#ffff",
      backgroundColor: "#0176d3",
      borderRadius: "25px",
      margin: "2px 0 2px 8px",
    },
    updateBtn: {
      fontSize: "12px",
      fontWeight: "600",
      padding: "4px 8px !important",
      textTransform: "none",
      color: "#ffff",
      backgroundColor: "#0176d3",
      borderRadius: "25px",
    },

    cancelBtn: {
      fontSize: "12px",
      padding: "3px 8px !important",
      marginRight: "8px",
      textTransform: "none",
      border: "0.5px solid #0176D3",
      color: "#0176D3",
      borderRadius: "25px",
    },
    plusBtn: {
      marginRight: "4px",
      fontSize: "16px !important",
    },
    addDialog: {
      width: "400px",
      height: "350px",
      //   position: "relative",
      //   display: "flex",
      //   flexDirection: "column",
      //   justifyContent: "space-between",
    },
    popupHeader: {
      marginTop: "-20px",
      marginLeft: "-24px",
      marginRight: "-24px",
      background: "#4b5558",
    },
    closeIconAdd: {
      display: "inline-block",
      color: "black",
      background: "#ffff",
      width: "18px",
      height: "18px",
      borderRadius: "50%",
      cursor: "pointer",
      textAlign: "center",
      position: "absolute",
      top: "5px",
      right: "8px",
      fontSize: "13px",
      fontWeight: 600,
    },
    addDelegationTitle: {
      height: "28px",
      textAlign: "center",

      fontWeight: 600,
      paddingTop: "5px",
      color: "#ffff",
    },
    fieldTitle: {
      fontWeight: 600,
      marginTop: "20px",
      fontSize: "13px",
    },
    required: {
      color: "red",
    },
    popupBtnsAdd: {
      textAlign: "center",
      marginTop: "25px",
    },
    cancelBtn: {
      fontSize: "12px",
      padding: "3px 8px !important",
      textTransform: "none",
      border: "0.5px solid #0176D3",
      color: "#0176D3",
    },
    saveBtn: {
      fontSize: "12px",
      fontWeight: "600",
      padding: "4px 8px !important",
      textTransform: "none",
      border: "1px solid #3599d1",
      color: "#ffff",
      backgroundColor: "#0176d3",
      marginRight: "8px",
    },
    deleteBtn: {
      fontSize: "12px",
      fontWeight: "600",
      padding: "4px 8px !important",
      textTransform: "none",
      border: "none",
      color: "#ffff",
      marginRight: "8px",
      backgroundColor: "red",
    },
    datePicker: {
      width: "100%",
      border: "1px solid #ccc",
      borderRadius: "5px",
      padding: "2px",
    },
  }));

  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [openDialogAdd, setOpenDialogAdd] = useState(false);
  const [delegationObj, setDelegationObj] = useState({
    id: "",
    startDate: new Date(),
    endDate: "",
    resourceId: "",
    delegatedDepartmentId: "",
    resource: "",
    delegatedDepartment: "",
    delegationId: "",
    delegatedResourceId: "",
    delegatedToResourceId: "",
    delegatedToResource: "",
    delegatedFromResource: "",
  });
  const [dateFormat, setDateFormat] = useState("dd/MM/yyyy");
  const [departments, setDepartments] = useState([]);
  const [fromResources, setFromResources] = useState([]);
  const [toResources, setToResources] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const [datesChanged, setDatesChanged] = useState(false);

  const departmentsData = useSelector(
    (state) => state.adminReducer.adminDepartmentsData
  );

  const getResourceListForDelegationData = useSelector(
    (state) => state.adminReducer.getResourceListForDelegationData
  );

  const resourcesListFromDelegateData = useSelector(
    (state) => state.adminReducer.resourcesListFromDelegateData
  );

  const getDelegatedResourceHistoryData = useSelector(
    (state) => state.adminReducer.getDelegatedResourceHistoryData
  );

  const createDelegationData = useSelector(
    (state) => state.adminReducer.createDelegationData
  );
  const generalSettingsData = useSelector(
    (state) => state.adminReducer.generalSettingsData
  );
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const onSearchChange = (e) => {
    setPage(0);
    setSearchText(e.target.value);
  };

  const filterData = () => {
    const changedData = JSON.parse(JSON.stringify(tableData));
    if (searchText.trim() !== "") {
      const filteredItems = changedData.filter(
        (val) =>
          (val.resourceName &&
            val.resourceName
              .toString()
              .trim()
              .toLowerCase()
              .includes(searchText.toString().trim().toLowerCase())) ||
          (val.resourceDeptName &&
            val.resourceDeptName
              .toString()
              .trim()
              .toLowerCase()
              .includes(searchText.toString().trim().toLowerCase())) ||
          (val.delegatedToResourceName &&
            val.delegatedToResourceName
              .toString()
              .trim()
              .toLowerCase()
              .includes(searchText.toString().trim().toLowerCase())) ||
          (val.createdBy &&
            val.createdBy
              .toString()
              .trim()
              .toLowerCase()
              .includes(searchText.toString().trim().toLowerCase()))
      );
      return filteredItems;
    }
    return changedData;
  };

  useEffect(() => {
    setRowsPerPage(10);
  }, [searchText]);

  const BootstrapInput = withStyles((theme) => ({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #ced4da !important",
      fontSize: 13,
      padding: "4px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  }))(InputBase);

  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };

  const onCancel = () => {
    setOpenDialogAdd(false);
    setDelegationObj({
      id: "",
      startDate: new Date(),
      endDate: "",
      resourceId: "",
      delegatedDepartmentId: "",
      resource: "",
      delegatedDepartment: "",
      delegationId: "",
      delegatedResourceId: "",
      delegatedToResourceId: "",
      delegatedToResource: "",
      delegatedFromResource: "",
    });
    setIsEditing(false);
    setIsDeleting(false);
    setIsBtnDisabled(false);
  };

  const onAddDelegation = () => {
    const objCopy = { ...delegationObj };
    if (
      !objCopy.startDate ||
      !objCopy.endDate ||
      String(objCopy.delegatedResourceId).trim().length == 0 ||
      String(objCopy.delegatedToResourceId).trim().length == 0
    ) {
      setMsgType("error");
      setEmptyErrMsg(true);
      setMsgText("All fields are required.");
    } else if (
      new Date(checkDates(objCopy.startDate)) >
      new Date(checkDates(objCopy.endDate))
    ) {
      setMsgType("error");
      setEmptyErrMsg(true);
      setMsgText("Start date cannot be greater than end date.");
    } else if (
      new Date(checkDates(objCopy.endDate)) <
      new Date(checkDates(objCopy.startDate))
    ) {
      setMsgType("error");
      setEmptyErrMsg(true);
      setMsgText("End date cannot be greater than start date.");
    } else {
      if (
        objCopy.startDate &&
        objCopy.endDate &&
        objCopy.delegatedResourceId &&
        objCopy.delegatedToResourceId
      ) {
        setIsBtnDisabled(true);
        objCopy.startDate = checkDates(objCopy.startDate);
        objCopy.endDate = checkDates(objCopy.endDate);
        dispatch(
          createDelegatedResourceHistory({
            delegationId: null,
            delegatedResourceId: objCopy.delegatedResourceId,
            delegatedToResourceId: objCopy.delegatedToResourceId,
            // resourceId: objCopy.resourceId,
            // delegatedDepartmentId: objCopy.delegatedDepartmentId,
            delegationStartDate: objCopy.startDate,
            delegationEndDate: objCopy.endDate,
            createdBy: "",
            createdDate: "",
            modifiedBy: "",
            modifiedDate: "",
            isActive: true,
          })
        );
        setOpenDialogAdd(false);
      }
    }
  };

  const onUpdateDelegation = () => {
    const objCopy = { ...delegationObj };
    if (isDeleting) {
      dispatch(
        createDelegatedResourceHistory({
          delegationId: objCopy.delegationId,
          delegatedResourceId: objCopy.delegatedResourceId,
          delegatedToResourceId: objCopy.delegatedToResourceId,
          delegationStartDate: objCopy.startDate,
          delegationEndDate: objCopy.endDate,
          createdBy: "",
          createdDate: "",
          modifiedBy: "",
          modifiedDate: "",
          isActive: false,
        })
      );
    } else {
      if (
        !objCopy.startDate ||
        !objCopy.endDate ||
        String(objCopy.delegatedResourceId).trim().length == 0 ||
        String(objCopy.delegatedToResourceId).trim().length == 0
      ) {
        setMsgType("error");
        setEmptyErrMsg(true);
        setMsgText("All fields are required.");
      } else if (
        new Date(checkDates(objCopy.startDate)) >
        new Date(checkDates(objCopy.endDate))
      ) {
        setMsgType("error");
        setEmptyErrMsg(true);
        setMsgText("Start date cannot be greater than end date.");
      } else if (
        new Date(checkDates(objCopy.endDate)) <
        new Date(checkDates(objCopy.startDate))
      ) {
        setMsgType("error");
        setEmptyErrMsg(true);
        setMsgText("End date cannot be greater than start date.");
      } else {
        if (
          objCopy.startDate &&
          objCopy.endDate &&
          objCopy.delegatedResourceId &&
          objCopy.delegatedToResourceId
        ) {
          objCopy.startDate = checkDates(objCopy.startDate);
          objCopy.endDate = checkDates(objCopy.endDate);
          dispatch(
            createDelegatedResourceHistory({
              delegationId: objCopy.delegationId,
              delegatedResourceId: objCopy.delegatedResourceId,
              delegatedToResourceId: objCopy.delegatedToResourceId,
              delegationStartDate: objCopy.startDate,
              delegationEndDate: objCopy.endDate,
              createdBy: "",
              createdDate: "",
              modifiedBy: "",
              modifiedDate: "",
              isActive: true,
            })
          );
          // setOpenDialogAdd(false);
        }
      }
    }
  };

  const checkDates = (date) => {
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    const d = date.getDate();
    const formattedDate = `${y}-${m < 10 ? `0${m}` : m}-${
      d < 10 ? `0${d}` : d
    }`;
    return formattedDate;
  };

  const onEditDelegation = (item) => {
    setIsEditing(true);
    setOpenDialogAdd(true);
    const {
      delegationStartDate,
      delegationEndDate,
      resourceName,
      resourceDeptName,
      resourceId,
      delegatedDepartmentId,
      delegatedDepartmentName,
      id,
      delegationId,
      delegatedToResourceName,
      delegatedToResourceDepartmentName,
      delegatedResourceId,
      delegatedToResourceId,
    } = item;
    setDelegationObj({
      ...delegationObj,
      startDate: new Date(delegationStartDate.split("T")[0].replace(/-/g, "/")),
      endDate: new Date(delegationEndDate.split("T")[0].replace(/-/g, "/")),
      delegatedFromResource: `${resourceName}, ${resourceDeptName}`,
      delegatedToResource: `${delegatedToResourceName}, ${delegatedToResourceDepartmentName}`,
      delegatedResourceId,
      delegatedToResourceId,
      delegationId,
    });
    setLoading(true);
    dispatch(
      getResourceListForDelegation(
        checkDates(
          new Date(
            new Date(delegationStartDate.split("T")[0].replace(/-/g, "/"))
          )
        ),
        checkDates(new Date(delegationEndDate.split("T")[0].replace(/-/g, "/")))
      )
    );
    dispatch(
      getResourceListForDelegationFromRole(
        checkDates(
          new Date(
            new Date(delegationStartDate.split("T")[0].replace(/-/g, "/"))
          )
        ),
        checkDates(new Date(delegationEndDate.split("T")[0].replace(/-/g, "/")))
      )
    );
  };

  const onDeleteIconClick = (item) => {
    setIsDeleting(true);
    setOpenDialogAdd(true);
    const {
      delegationStartDate,
      delegationEndDate,
      resourceName,
      resourceDeptName,
      resourceId,
      delegatedDepartmentId,
      delegatedDepartmentName,
      id,
      delegationId,
      delegatedToResourceName,
      delegatedToResourceDepartmentName,
      delegatedResourceId,
      delegatedToResourceId,
    } = item;
    setDelegationObj({
      ...delegationObj,
      startDate: new Date(delegationStartDate),
      endDate: new Date(delegationEndDate),
      delegatedFromResource: `${resourceName}, ${resourceDeptName}`,
      delegatedToResource: `${delegatedToResourceName}, ${delegatedToResourceDepartmentName}`,
      delegatedResourceId,
      delegatedToResourceId,
      delegationId,
    });
  };
  useEffect(() => {
    setLoading(true);
    dispatch(getDelegatedResourceHistory());
    dispatch(getAdminDepartments());
  }, []);

  useEffect(() => {
    if (
      getDelegatedResourceHistoryData.status &&
      (getDelegatedResourceHistoryData.status === 200 ||
        getDelegatedResourceHistoryData.status === 400)
    ) {
      setTableData(
        getDelegatedResourceHistoryData.data
          ? getDelegatedResourceHistoryData.data
          : []
      );
      setLoading(false);
    }
  }, [getDelegatedResourceHistoryData]);

  useEffect(() => {
    if (createDelegationData.status && createDelegationData.status === 200) {
      setMsgType("success");
      setEmptyErrMsg(true);
      setMsgText(
        isEditing
          ? "Delegation updated successfully"
          : isDeleting
          ? "Delegation removed successfully"
          : "Delegation added successfully"
      );
      dispatch(getDelegatedResourceHistory());
      onCancel();
      createDelegationData.status = null;
    } else if (
      createDelegationData.status &&
      createDelegationData.status > 200
    ) {
      setMsgType("error");
      setEmptyErrMsg(true);
      setMsgText(createDelegationData.message);
      onCancel();
      createDelegationData.status = null;
    }
  }, [createDelegationData]);

  useEffect(() => {
    if (
      departmentsData.status &&
      (departmentsData.status === 200 || departmentsData.status === 400)
    ) {
      setDepartments(
        departmentsData.data
          ? departmentsData.data
              .sort((a, b) => {
                const nameA = a.department.toUpperCase();
                const nameB = b.department.toUpperCase();

                if (nameA < nameB) {
                  return -1;
                }
                if (nameA > nameB) {
                  return 1;
                }
                return 0;
              })
              .map((obj) => {
                return {
                  label: obj.department,
                  value: obj.department,
                  department_id: obj.department_id,
                };
              })
          : []
      );
    }
  }, [departmentsData]);

  useEffect(() => {
    if (
      getResourceListForDelegationData.status &&
      (getResourceListForDelegationData.status === 200 ||
        getResourceListForDelegationData.status === 400)
    ) {
      const changedData = getResourceListForDelegationData.data
        ? getResourceListForDelegationData.data
            .sort((a, b) => {
              const nameA = a.resourceName.toUpperCase();
              const nameB = b.resourceName.toUpperCase();

              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            })
            .map((obj) => {
              return {
                label: `${obj.resourceName}, ${obj.departmentName}`,
                value: `${obj.resourceName}, ${obj.departmentName}`,
                resourceId: obj.resourceId,
              };
            })
        : [];
      setToResources(changedData);
      setLoading(false);
    }
  }, [getResourceListForDelegationData]);

  useEffect(() => {
    if (
      resourcesListFromDelegateData.status &&
      (resourcesListFromDelegateData.status === 200 ||
        resourcesListFromDelegateData.status === 400)
    ) {
      const changedData = resourcesListFromDelegateData.data
        ? resourcesListFromDelegateData.data
            .sort((a, b) => {
              const nameA = a.resourceName.toUpperCase();
              const nameB = b.resourceName.toUpperCase();

              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            })
            .map((obj) => {
              return {
                label: `${obj.resourceName}, ${obj.departmentName}`,
                value: `${obj.resourceName}, ${obj.departmentName}`,
                resourceId: obj.resourceId,
              };
            })
        : [];
      setLoading(false);
      if (!JSON.parse(localStorage.getItem("roles")).includes("RM")) {
        setDelegationObj({
          ...delegationObj,
          delegatedResourceId:
            changedData.length > 0 ? changedData[0].resourceId : ``,
          delegatedFromResource:
            changedData.length > 0 ? changedData[0].label : ``,
        });
      }
      setFromResources(changedData);
    }
  }, [resourcesListFromDelegateData]);

  useEffect(() => {
    if (getResponse(generalSettingsData, []).length > 0)
      setDateFormat(getResponse(generalSettingsData, [])[0].date_format);
  }, [generalSettingsData]);

  useEffect(() => {
    if (datesChanged) {
      setDatesChanged(false);
      if (delegationObj.startDate && delegationObj.endDate) {
        setLoading(true);
        dispatch(
          getResourceListForDelegation(
            checkDates(new Date(delegationObj.startDate)),
            checkDates(new Date(delegationObj.endDate))
          )
        );
        dispatch(
          getResourceListForDelegationFromRole(
            checkDates(new Date(delegationObj.startDate)),
            checkDates(new Date(delegationObj.endDate))
          )
        );
      }
    }
  }, [datesChanged]);

  const onDelegateOpenClick = () => {
    setToResources([]);
    setFromResources([]);
    setOpenDialogAdd(true);
  };

  return (
    <Paper elevation={0} className={classes.tablePaper}>
      <Grid
        container
        className={classes.searchSection}
        spacing={0}
        style={{
          justifyContent: tableData.length > 0 ? "space-between" : "flex-end",
        }}
      >
        {tableData.length > 0 && (
          <Grid item>
            <FormControl variant="outlined" className={classes.searchControl}>
              <OutlinedInput
                className={classes.searchTextField}
                type="text"
                placeholder="Search"
                onChange={(e) => onSearchChange(e)}
                value={searchText}
                endAdornment={
                  <InputAdornment position="start">
                    <SearchIcon className={classes.searchIcon} />
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>
        )}
        <Grid item>
          <Button
            className={classes.addBtn}
            variant="contained"
            color="primary"
            onClick={() => onDelegateOpenClick()}
          >
            <span className={classes.plusBtn}>+</span>
            Delegate
          </Button>
        </Grid>
      </Grid>
      {filterData(tableData).length > 0 ? (
        <div style={{ display: "flex" }}>
          <table>
            <thead>
              <tr>
                <td style={{ height: "30px" }}></td>
              </tr>
              <tbody>
                {filterData(tableData)
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((tableItem, i) => (
                    <tr
                      key={i}
                      onMouseEnter={() => setCurrentRow(i)}
                      onMouseLeave={() => setCurrentRow(null)}
                      style={{ cursor: "pointer" }}
                    >
                      <td
                        style={{
                          cursor: "pointer",
                          height:
                            tableItem.delegatedToResourceName.length > 30 ||
                            tableItem.resourceName.length > 30 ||
                            tableItem.createdBy.length > 30
                              ? "50px"
                              : "30px",
                          width: "20px",
                          marginLeft: "-10px",
                          display: "block",
                        }}
                      ></td>
                    </tr>
                  ))}
              </tbody>
            </thead>
          </table>
          <table className="generalSettingsTable">
            <thead>
              <tr>
                {/* <td>Resource</td>
              <td>Delegated From</td>
              <td>Delegated To</td>
              <td>Manager</td>
              <td>Start Date</td>
              <td>End Date</td>
              <td>Delegated By</td> */}
                {/* <td>Department</td> */}
                <td>Delegated To</td>
                <td>Delegated From</td>
                <td>Delegated By</td>
                <td>Start Date</td>
                <td>End Date</td>
              </tr>
            </thead>

            <tbody>
              {filterData(tableData)
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((tableItem, i) => (
                  <tr
                    key={i}
                    onMouseEnter={() => setCurrentRow(i)}
                    onMouseLeave={() => setCurrentRow(null)}
                    style={{
                      cursor: tableItem.isEditable ? "pointer" : "default",
                    }}
                  >
                    <td style={{ position: "relative" }}>
                      {currentRow == i && tableItem.isEditable && (
                        <span className={classes.actionBtnContainer}>
                          <span>
                            <EditIcon
                              style={{
                                color: "#0070D2",
                                fontSize: "16px",
                                cursor: "pointer",
                                marginLeft: "px",
                              }}
                              onClick={() => {
                                onEditDelegation(tableItem);
                              }}
                            />
                          </span>
                          <span>
                            <DeleteForeverIcon
                              style={{
                                color: "red",
                                fontSize: "16px",
                                cursor: "pointer",
                              }}
                              onClick={() => onDeleteIconClick(tableItem)}
                            />
                          </span>
                        </span>
                      )}
                      {tableItem.delegatedToResourceName}
                    </td>
                    <td>{tableItem.resourceName}</td>
                    <td>
                      <span>{tableItem.createdBy}</span>
                    </td>
                    <td>
                      {formatDateBySetting(
                        formatBackToDateFromSetting(
                          tableItem.delegationStartDate.split("T")[0],
                          "YYYY-MM-DD"
                        ),
                        dateFormat
                      )}
                    </td>
                    <td>
                      {formatDateBySetting(
                        formatBackToDateFromSetting(
                          tableItem.delegationEndDate.split("T")[0],
                          "YYYY-MM-DD"
                        ),
                        dateFormat
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div
          style={{ textAlign: "center", padding: "20px 0", fontWeight: 600 }}
        >
          {tableData.length == 0
            ? "No Delegations"
            : filterData(tableData).length == 0
            ? "No delegations found"
            : null}
        </div>
      )}
      {filterData(tableData).length > 10 && (
        <Grid container className={classes.paginationSection} spacing={0}>
          <Grid item lg={12}>
            <div style={{ float: "right", marginTop: "6px" }}>
              <Pagination
                count={Math.ceil(filterData(tableData).length / rowsPerPage)}
                showFirstButton
                showLastButton
                page={page + 1}
                onChange={handleChangePage}
                color="primary"
                style={{ float: "right" }}
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    page={getPaginationPageNumber(
                      item.page - 1,
                      filterData(tableData).length,
                      rowsPerPage
                    )}
                  />
                )}
              />
            </div>{" "}
            <div style={{ float: "right", marginTop: "6px" }}>
              <div style={{ float: "left", marginTop: "4px" }}>Showing</div>
              <FormControl className="tableRowsDdl">
                <Select
                  labelId="demo-customized-select-label"
                  id="demo-customized-select"
                  value={rowsPerPage}
                  onChange={handleChangeRowsPerPage}
                  input={<BootstrapInput />}
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={15}>15</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                </Select>
              </FormControl>
            </div>
          </Grid>
        </Grid>
      )}
      <Dialog
        open={openDialogAdd}
        onClose={() => onCancel()}
        aria-labelledby="max-width-dialog-title"
        disableBackdropClick
      >
        {openDialogAdd && (
          <DialogContent
            className={classes.addDialog}
            style={{
              height: isDeleting && "auto",
              width: isDeleting && "300px",
            }}
          >
            <div className={classes.popupHeader}>
              <span className={classes.closeIconAdd} onClick={() => onCancel()}>
                x
              </span>

              <div className={classes.addDelegationTitle}>
                {isEditing
                  ? "Update Delegation"
                  : isDeleting
                  ? "Delete Delegation"
                  : "Delegate Resource"}
              </div>
            </div>
            {isDeleting ? (
              <>
                <p style={{ textAlign: "center", fontWeight: 600 }}>
                  Do you want to delete the delegation?
                </p>
                <div className={classes.popupBtnsAdd}>
                  <Button
                    className={classes.deleteBtn}
                    variant="contained"
                    color="primary"
                    onClick={() => onUpdateDelegation()}
                  >
                    Delete
                  </Button>
                  <Button
                    variant="outlined"
                    className={classes.cancelBtn}
                    color="primary"
                    onClick={onCancel}
                  >
                    Cancel
                  </Button>
                </div>
              </>
            ) : (
              <>
                <Grid container spacing={2}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      padding: "0 5px",
                    }}
                  >
                    <div style={{ marginRight: "5px", marginLeft: "4px" }}>
                      {" "}
                      <div className={classes.fieldTitle}>
                        Start Date<span className={classes.required}>*</span>
                      </div>
                      <CustomDatePicker
                        dateFormat={dateFormat}
                        dateValue={delegationObj.startDate}
                        setDateValue={(date) => {
                          setDatesChanged(true);
                          setToResources([]);
                          setFromResources([]);
                          setDelegationObj({
                            ...delegationObj,
                            delegatedResourceId: "",
                            delegatedToResourceId: "",
                            delegatedToResource: "",
                            delegatedFromResource: "",
                            startDate: date ? new Date(date) : null,
                          });
                        }}
                        itemWidth="100%"
                        classVal="datePicker"
                        disablePasts={true}
                      />
                    </div>

                    <div>
                      {" "}
                      <div className={classes.fieldTitle}>
                        End Date<span className={classes.required}>*</span>
                      </div>
                      <CustomDatePicker
                        dateFormat={dateFormat}
                        dateValue={delegationObj.endDate}
                        setDateValue={(date) => {
                          setDatesChanged(true);
                          setToResources([]);
                          setFromResources([]);
                          setDelegationObj({
                            ...delegationObj,
                            delegatedResourceId: "",
                            delegatedToResourceId: "",
                            delegatedToResource: "",
                            delegatedFromResource: "",
                            endDate: date ? new Date(date) : null,
                          });
                        }}
                        itemWidth="100%"
                        classVal="datePicker"
                        disablePasts={true}
                      />
                    </div>
                  </div>

                  <Grid item lg={12}>
                    <div className={classes.fieldTitle}>
                      Delegate From
                      <span className={classes.required}>*</span>
                    </div>
                    <AntSelect
                      style={{ width: "100%" }}
                      showArrow
                      showSearch
                      options={fromResources}
                      value={delegationObj.delegatedFromResource}
                      disabled={
                        !JSON.parse(localStorage.getItem("roles")).includes(
                          "RM"
                        )
                      }
                      onChange={(value, obj) =>
                        setDelegationObj({
                          ...delegationObj,
                          delegatedResourceId: obj.resourceId,
                          delegatedFromResource: value,
                        })
                      }
                      // placeholder="Select Department"
                      // defaultValue={nodeObj.resource?nodeObj.re}
                    ></AntSelect>
                  </Grid>
                  <Grid item lg={12}>
                    <div className={classes.fieldTitle}>
                      Delegate To<span className={classes.required}>*</span>
                    </div>
                    <AntSelect
                      style={{ width: "100%" }}
                      showArrow
                      showSearch
                      options={toResources}
                      value={delegationObj.delegatedToResource}
                      onChange={(value, obj) => {
                        setDelegationObj({
                          ...delegationObj,
                          delegatedToResourceId: obj.resourceId,
                          delegatedToResource: value,
                        });
                      }}
                      placeholder="Select Resource"
                      // defaultValue={nodeObj.resource?nodeObj.re}
                    ></AntSelect>
                  </Grid>
                </Grid>
                <div className={classes.popupBtnsAdd}>
                  {isEditing ? (
                    <Button
                      className={classes.saveBtn}
                      variant="contained"
                      color="primary"
                      onClick={() => onUpdateDelegation()}
                    >
                      Update
                    </Button>
                  ) : (
                    <Button
                      className={classes.saveBtn}
                      variant="contained"
                      color="primary"
                      onClick={onAddDelegation}
                      disabled={isBtnDisabled}
                    >
                      Add
                    </Button>
                  )}
                  <Button
                    variant="outlined"
                    className={classes.cancelBtn}
                    color="primary"
                    onClick={onCancel}
                  >
                    Cancel
                  </Button>
                </div>
              </>
            )}
          </DialogContent>
        )}
      </Dialog>
      {emptyErrMsg && (
        <ActionMessages type={msgType} isClosed={isClosed} message={msgText} />
      )}
      {loading && <Loading />}
    </Paper>
  );
};

export default Delegations;
